import rest from 'Services/restFootData';

// Fetch the canonical ranking rules: those keyed on the OPTA rankId (meta_import_uuid).
// This is a global referential, independent of any tournament.
export function fetchRankingRules() {
  const params = {
    'exists[metaImportUuid]': true,
    pagination: 0,
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_RANKING_RULES' });

    return rest.get('ranking_rules', { params }).then(
      res => dispatch({ type: 'FETCH_RANKING_RULES_FULFILLED', payload: res.data }),
      err => dispatch({ type: 'FETCH_RANKING_RULES_REJECTED', payload: err.response })
    );
  };
}
